/**
 * Copyright 2022 Design Barn Inc.
 */

/* eslint-disable react/jsx-props-no-spreading */

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React from 'react';

import { Button } from './button';
import type { ErrorBaseProps } from './error-base';
import ErrorBase from './error-base';

const title = (
  <h1>
    Something went wrong somewhere{' '}
    <span role="img" aria-label="grinning-face-with-sweat">
      😅
    </span>
  </h1>
);

const details = (
  <p>
    You could either go back a page, or{' '}
    <Link href="https://lottiefiles.zendesk.com/hc/en-us/requests/new">
      <span className="cursor-pointer text-teal-300">contact our customer support team. </span>
    </Link>
    We&apos;re always eager to help!
  </p>
);

const GeneralError = (props: ErrorBaseProps): React.ReactElement => {
  const router = useRouter();

  const back = React.useCallback(() => router.back(), [router]);

  const action = React.useMemo(
    () => (
      <Button size="lg" onClick={back}>
        Back to previous page
      </Button>
    ),
    [back],
  );

  return <ErrorBase action={action} {...props} title={title} details={details} />;
};

export default GeneralError;
